import React, { useState, forwardRef, useImperativeHandle } from "react";
import { SimpleDialog } from "simple-ui-components";

import { getTranslation } from "../languageProvider";
import Documents from "./documents";

export const EditDocuments = forwardRef((props, ref) => {
  const { Dialog, DialogBody } = SimpleDialog;

  const [open, setOpen] = useState(false);
  const [currentRoute, setCurrentRoute] = useState(undefined);

  const handleClose = () => setOpen(false);

  useImperativeHandle(ref, () => ({
    Open(route) {
      setOpen(true);
      setCurrentRoute(route);
    },
  }));

  if (!open) return null;
  return (
    <Dialog
      theme="default"
      size="sm"
      close={handleClose}
      open={open}
      title={getTranslation("0176")}
    >
      <DialogBody>
        <Documents currentRoute={currentRoute} />
      </DialogBody>
    </Dialog>
  );
});
